/**
 * Module-level auth event capture.
 * Must be imported BEFORE React renders (in main.jsx) so the subscription
 * is set up before Supabase fires PASSWORD_RECOVERY during its async init.
 */
import { supabase } from './supabase'

let _pendingMode = null // 'set-password' | null
let _needsLoginRedirect = false

supabase.auth.onAuthStateChange((event) => {
  if (event === 'PASSWORD_RECOVERY') {
    _pendingMode = 'set-password'
    _needsLoginRedirect = true
  }
})

/** Returns and clears the pending auth mode. */
export function consumePendingAuthMode() {
  const mode = _pendingMode
  _pendingMode = null
  return mode
}

/** Returns true if we need to navigate to /login due to a recovery event. */
export function needsLoginRedirect() {
  return _needsLoginRedirect
}

/** Call once the redirect has been handled. */
export function clearLoginRedirect() {
  _needsLoginRedirect = false
}
